"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowerCase = exports.localeLowerCase = exports.noCase = exports.dotCase = exports.snakeCase = exports.pascalCase = exports.pascalCaseTransformMerge = exports.pascalCaseTransform = exports.camelCase = exports.camelCaseTransformMerge = exports.camelCaseTransform = exports.formatComment = exports.shouldIncludeHandler = exports.shouldIncludeHostCall = void 0;
function shouldIncludeHostCall(context) {
    let roles = context.config.hostRoles;
    return shouldInclude(context, roles);
}
exports.shouldIncludeHostCall = shouldIncludeHostCall;
function shouldIncludeHandler(context) {
    let roles = context.config.handlerRoles;
    return shouldInclude(context, roles);
}
exports.shouldIncludeHandler = shouldIncludeHandler;
function shouldInclude(context, roles) {
    if (context.role != undefined) {
        if (roles == undefined || roles.indexOf(context.role.name.value) == -1) {
            return false;
        }
    }
    else if (context.config.skipInterface == true) {
        return false;
    }
    return true;
}
function formatComment(prefix, text, wrapLength = 80) {
    if (text == undefined) {
        return "";
    }
    let textValue = "";
    if (!text || typeof text === "string") {
        textValue = text;
    }
    else {
        textValue = text.value;
    }
    // Replace single newline characters with space so that the logic below
    // handles line wrapping. Multiple newlines are preserved. It was simpler
    // to do this than regex.
    for (i = 1; i < textValue.length - 1; i++) {
        if (textValue[i] == "\n" &&
            textValue[i - 1] != "\n" &&
            textValue[i + 1] != "\n") {
            textValue = textValue.substring(0, i) + " " + textValue.substring(i + 1);
        }
    }
    let comment = "";
    let line = "";
    let word = "";
    for (var i = 0; i < textValue.length; i++) {
        let c = textValue[i];
        if (c == " " || c == "\n") {
            if (line.length + word.length > wrapLength) {
                if (comment.length > 0) {
                    comment += "\n";
                }
                comment += prefix + line.trim();
                line = word.trim();
                word = " ";
            }
            else if (c == "\n") {
                line += word;
                if (comment.length > 0) {
                    comment += "\n";
                }
                comment += prefix + line.trim();
                line = "";
                word = "";
            }
            else {
                line += word;
                word = c;
            }
        }
        else {
            word += c;
        }
    }
    if (line.length + word.length > wrapLength) {
        if (comment.length > 0) {
            comment += "\n";
        }
        comment += prefix + line.trim();
        line = word.trim();
    }
    else {
        line += word;
    }
    if (line.length > 0) {
        if (comment.length > 0) {
            comment += "\n";
        }
        comment += prefix + line.trim();
    }
    if (comment.length > 0) {
        comment += "\n";
    }
    return comment;
}
exports.formatComment = formatComment;
// The following functions are from
// https://github.com/blakeembrey/change-case
// Pasted here to avoid an NPM dependency for the CLI.
function camelCaseTransform(input, index) {
    if (index === 0)
        return input.toLowerCase();
    return pascalCaseTransform(input, index);
}
exports.camelCaseTransform = camelCaseTransform;
function camelCaseTransformMerge(input, index) {
    if (index === 0)
        return input.toLowerCase();
    return pascalCaseTransformMerge(input);
}
exports.camelCaseTransformMerge = camelCaseTransformMerge;
function camelCase(input, options = {}) {
    return pascalCase(input, Object.assign({ transform: camelCaseTransform }, options));
}
exports.camelCase = camelCase;
function pascalCaseTransform(input, index) {
    const firstChar = input.charAt(0);
    const lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") {
        return `_${firstChar}${lowerChars}`;
    }
    return `${firstChar.toUpperCase()}${lowerChars}`;
}
exports.pascalCaseTransform = pascalCaseTransform;
function pascalCaseTransformMerge(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
exports.pascalCaseTransformMerge = pascalCaseTransformMerge;
function pascalCase(input, options = {}) {
    return noCase(input, Object.assign({ delimiter: "", transform: pascalCaseTransform }, options));
}
exports.pascalCase = pascalCase;
function snakeCase(input, options = {}) {
    return dotCase(input, Object.assign({ delimiter: "_" }, options));
}
exports.snakeCase = snakeCase;
function dotCase(input, options = {}) {
    return noCase(input, Object.assign({ delimiter: "." }, options));
}
exports.dotCase = dotCase;
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
const DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
const DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function noCase(input, options = {}) {
    const { splitRegexp = DEFAULT_SPLIT_REGEXP, stripRegexp = DEFAULT_STRIP_REGEXP, transform = lowerCase, delimiter = " ", } = options;
    let result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    let start = 0;
    let end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
exports.noCase = noCase;
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce((input, re) => input.replace(re, value), input);
}
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
const SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    az: {
        regexp: /\u0130/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            Į: "\u012F\u0307",
            Ì: "\u0069\u0307\u0300",
            Í: "\u0069\u0307\u0301",
            Ĩ: "\u0069\u0307\u0303",
        },
    },
};
/**
 * Localized lower case.
 */
function localeLowerCase(str, locale) {
    const lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang)
        return lowerCase(str.replace(lang.regexp, (m) => lang.map[m]));
    return lowerCase(str);
}
exports.localeLowerCase = localeLowerCase;
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}
exports.lowerCase = lowerCase;
//# sourceMappingURL=index.js.map